<template>
    <button type="button" :disabled="disabled" @click="activate" :class="[channel.active ? 'btn btn-success btn-sm mr-5 active button-width' : 'btn btn-danger btn-sm active mr-5 button-width']">
      <i :class="[disabled ? 'fa fa-spinner fa-spin mr-5' : channel.active ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>
      {{channel.name | translate}}
    </button>
</template>
<script>
export default {
  props: ['channel', 'model'],
  data () {
    return {
      disabled: false
    }
  },
  methods: {
    activate () {
      this.disabled = true
      API.put(`inventory/${this.model}`, {channels: [{name: this.channel.name, active: !this.channel.active}]})
        .then(res => {
          this.disabled = false
          this.$emit('pushAlert', {channel: this.channel.name, active: !this.channel.active})
          this.$store.commit('pushAlert', {dismiss: 4, type: 'success', message: `Channel ${this.channel.name} was updated!`, icon: 'icon fa fa-check', show: true})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'danger', dismiss: 4, message: 'Error!', icon: 'icon fa fa-ban', show: true})
          this.disabled = false
        })
    }
  }
}
</script>
<style>
  .button-width {
    width: 105px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/TableRows/ProductChannelsRow.vue